export default __webpack_public_path__ + "static/media/screen5.57422db2.png";